import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      item: item.href ? `https://liveorbit.github.io${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
        {items.map((item, idx) => (
          <span key={idx} className="flex items-center gap-1.5">
            {idx > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
            )}
            {item.href && idx < items.length - 1 ? (
              <Link
                to={item.href}
                className="text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={idx === items.length - 1 ? 'text-foreground-200 font-medium' : 'text-foreground-400'}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}